<div class="container u-flex">
  <div class="content">
    @if (errorConfig) {
      <generic-error
        [config]="errorConfig"
        (onAction)="handleAction($event)"
        data-test-id="errorPage"
      ></generic-error>
    }
  </div>
</div>
